/**
 * Shared source of truth for deriving the running/failed treatment shown on
 * conversation list surfaces. Kept in a component-free module (paired with
 * ConversationRunStateLabel.tsx) so files that only need the derivation logic
 * don't import a component, satisfying react-refresh's only-export-components
 * rule.
 */
export type ConversationRunState = 'running' | 'failed' | 'idle';

export const RUN_STATE_WORKING_LABEL = 'Working…';
export const RUN_STATE_FAILED_LABEL = 'Failed';

/**
 * Derive the run-state treatment for a conversation. Running takes precedence
 * over failed: an active chain retrying after a prior failure should show as
 * running, not failed. `hasActiveChain` defaults to falsy since existing
 * payloads/fixtures omit the field.
 */
export function deriveConversationRunState(input: {
  hasActiveChain?: boolean | null;
  lastChainFailed?: boolean | null;
}): ConversationRunState {
  if (input.hasActiveChain) {
    return 'running';
  }
  if (input.lastChainFailed) {
    return 'failed';
  }
  return 'idle';
}
